export default __webpack_public_path__ + "static/media/parcerias.69ec608c.png";